// C2wSuperxAllPrjLayout.jsx
import { Outlet, useLocation } from 'react-router';
import { useState, useEffect } from 'react';
import C2wSuperxAllBatch from './superxBatch';

const C2wSuperxAllPrjLayout = () => {
  const location = useLocation();
  const [showSuperxPrjAll, setShowSuperxAllPrj] = useState(false);

  useEffect(() => {
    // Show AllBatch only on /superx-batch/:slug (NOT /project-detail)
    const isBatchSlugPage =
      location.pathname.split("/").length === 3 &&
      location.pathname.startsWith("/superx-batch/");

    setShowSuperxAllPrj(isBatchSlugPage);
  }, [location]);

  return (
    <>
      <div style={{ display: showSuperxPrjAll ? 'block' : 'none' }}>
        <C2wSuperxAllBatch />
      </div>

      <Outlet />
    </>
  );
};

export default C2wSuperxAllPrjLayout;
